import { z } from "zod";

export const openAiEmbeddingSmallModel =
  "openai:text-embedding-3-small" as const;

export const textEmbedding3SmallMaxTokens = 8191;
export const minEmbeddableLength = 60;

export const EmbeddingSourceTypeSchema = z.enum([
  "fact",
  "asset",
  "note",
  "contact",
]);

export type EmbeddingSourceType = z.infer<typeof EmbeddingSourceTypeSchema>;

export const VectorSchema = z.array(z.number());

const EmbeddingBase = z.object({
  organizationId: z.uuid(),
  sourceType: EmbeddingSourceTypeSchema,
  sourceId: z.uuid(),
  contentHash: z.string(),
});

export const CreateEmbeddingSchema = z.discriminatedUnion("model", [
  z.object({
    ...EmbeddingBase.shape,
    model: z.literal(openAiEmbeddingSmallModel),
    embedOpenAiSmall: VectorSchema,
  }),
]);

export type CreateEmbedding = z.infer<typeof CreateEmbeddingSchema>;

export const SimilarMatchSchema = z.object({
  sourceId: z.string(),
  sourceType: EmbeddingSourceTypeSchema,
  similarity: z.number(),
});

export type SimilarMatch = z.infer<typeof SimilarMatchSchema>;

export const RetrievalHitSchema = z.object({
  sourceType: EmbeddingSourceTypeSchema,
  /** Block path for facts, UUID for everything else. */
  id: z.string(),
  title: z.string(),
  content: z.string(),
  similarity: z.number(),
});

export type RetrievalHit = z.infer<typeof RetrievalHitSchema>;
